/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { SxProps, Theme } from '@mui/material';

export const storeLocatorSideListElementSX: SxProps = {
	width: '100%',
	whiteSpace: 'nowrap',
};

export const tittleStyle: SxProps<Theme> = (theme) => ({
	fontWeight: '800',
	textTransform: 'uppercase',
	fontSize: 'var(--font-size-lg) !important',

	[theme.breakpoints.down('sm')]: {
		textAlign: 'center',
	},
});

export const styleBtn: SxProps = {
	borderRadius: '24px',
	fontWeight: 'bold',
	height: '46px',
	'&:hover': {
		backgroundColor: '#2682E7',
	},
};

export const styleSubText: SxProps<Theme> = (theme) => ({
	fontSize: 'var(--font-size-default) !important',

	[theme.breakpoints.down('sm')]: {
		textAlign: 'center',
		fontSize: 'var(--font-size-body) !important',
	},
});

export const containerResults: SxProps = {
	paddingTop: '0',
};
export const containerSearch: SxProps = {
	paddingBottom: '0',
};

export const textMobileMex: SxProps<Theme> = ({
	fontSize: 'var(--font-size-lg)',
	textAlign: 'center',
	textTransform: 'uppercase',
	fontWeight: '800',
	borderTop: '1px solid #D9D9D9',
	marginTop: '24px',
});
